import React, { Component } from 'react'
import { exportReportsCSV } from '../../../../services/api/InvoiceValidationServices'
import { saveAs } from 'file-saver'
import { message } from 'antd'

class ExportRecords extends Component {
    state = {
        error: '',
        loading: false
    }

    _handleExportRecords = async () => {
        const { request_id, filter, filename } = this.props
        const { status, tracking_number, order_number, partner_tracking_number, payment_status } = filter
        const query = {
            request_id,
            status,
            payment_status,
            order_number,
            tracking_number,
            partner_tracking_number,
        }

        this.setState({
            loading: true
        })
        try {
            const data = await exportReportsCSV(request_id, query)
            const file = new File([data], `Export_checking_${filename}.csv`, { type: 'application/csv; charset=UTF-8' })
            saveAs(file)
        } catch (error) {
            message.error(error.message)
        } finally {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        const { loading, error } = this.state

        return (
            <div className="ExportRecords ml-0">
                <button className="btn btn-primary" disabled={loading} onClick={this._handleExportRecords}>
                    <i className="fas fa-upload mr-1" /> {loading ? 'Exporting...' : 'Export CSV'}
                </button>
                {error && (
                    <div className="text-danger">{error}</div>
                )}
            </div>
        )
    }

}

export default ExportRecords